export function getRandomMapData(sections, code) {
  return (
    'code;value\n' +
    sections
      .map((section) => {
        return [section.properties[code ?? 'hc-key'], Math.floor(Math.random() * 100) + 1].join(';');
      })
      .join('\n')
  );
}

export function isMapKeyIncompatible(mapData) {
  return mapData.some(function (d) {
    let prop = d.properties && d.properties['hc-key'];
    if (prop) {
      prop = prop.split('-');
      return prop.length - 1 >= 2 && prop[prop.length - 1].length <= 4;
    }
    return false;
  });
}

export function getCompatibleMapKey(mapData) {
  let foundCode;
  // eslint-disable-next-line array-callback-return
  mapData.some(function (d) {
    /*
     
    //Uncomment this when bug in highmaps fixed:
    https://github.com/highcharts/highcharts/issues/16920

    if (d.id && d.properties && d.properties['fips']) {
      foundCode = 'fips';
      return true;
    }*/
    if (d.id && d.properties && d.properties.name) {
      foundCode = 'name';
      return true;
    }
    if (d.id && d.properties && d.properties['hc-a2']) {
      foundCode = 'hc-a2';
      return true;
    }
  });
  return foundCode;
}

export function isShortCode(mData, code) {
  return (
    (mData.properties['iso-a2'] && mData.properties['iso-a2'] === code) ||
    (mData.properties['hc-a2'] && mData.properties['hc-a2'] === code)
  );
}

export function isLongCode(mData, code) {
  return mData.properties['iso-a3'] && mData.properties['iso-a3'] === code;
}

export const isTilemap = (chosenWizardTemplate) =>
  chosenWizardTemplate?.title && ['Tilemap circle', 'Honeycomb'].indexOf(chosenWizardTemplate.title) > -1;
export const isPointMap = (chosenWizardTemplate) =>
  chosenWizardTemplate?.title && ['Point map'].indexOf(chosenWizardTemplate.title) > -1;
export const isPatternFill = (chosenWizardTemplate) =>
  chosenWizardTemplate?.title && ['Pattern fill'].indexOf(chosenWizardTemplate.title) > -1;
export const isPointMapFromConfig = (options) =>
  options?.chart?.type === 'pointmap' || options?.series?.some((serie) => serie.type === 'mappoint');
